import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type LiveboardsStore = {
  selectedLiveboardId: string | null;
  setSelectedLiveboardId: (liveboardId: string | null) => void;
};

export const useLiveboardsStore = create<LiveboardsStore>()(
  persist(
    (set) => ({
      selectedLiveboardId: null,
      setSelectedLiveboardId: (liveboardId) => set({ selectedLiveboardId: liveboardId }),
    }),
    {
      name: "liveboards",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        selectedLiveboardId: state.selectedLiveboardId,
      }),
    },
  ),
);
